<template>
  <div class="landing-header">
   <div class="header">
      <div class="logo">
        <img class="logo-img show" src="@/assets/image/landing/logo.png" alt="优普道" />
		 <img class="logo-img mini-show" src="@/assets/image/landing/logo-l.png" alt="优普道" />
      </div>

      <a class="phone show" href="tel:4006036669"><img class="mr-1" src="@/assets/image/phone.png" /> 400 603 6669</a>
	  <a class="phone mini-show" href="tel:4006036669"><img class="mr-1" src="@/assets/image/landing/logo-r.png" /></a>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
  },
  mounted() {},
  watch: {
    $route(value) {
      this.value = value.query.name || "";
    },
  },
};
</script>
<style lang="scss" scoped>
.landing-header {
  @include container();
  padding: 0 10px;
  .header {
    height: 70px;
    @include flex-between();
    margin: 0 auto;
    position: relative;
	flex-wrap: wrap;
    .logo {
      cursor: pointer;
    }

    .phone {
      @include flex-center();

      img {
        width: 25px;
        // height: 25px;
      }

      font-size: 20px;
      font-weight: bold;
      color: #f55b46;
    }
  }
}
.mini-show{
	display: none !important;
}
@media only screen and (max-width: 481px) {
			.logo-img{
				width: 100%;
			}
			.mini-show{
				display: block !important;
			}
			.show{
				display: none  !important;
			}
}
</style>
